<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: undefined,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [
        {
          beforeInit(chart) {
            // Get a reference to the original fit function
            const originalFit = chart.legend.fit;

            // Override the fit function
            chart.legend.fit = function fit() {
              // Call the original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              // Change the height as suggested in other answers
              this.height += 24;
            };
          },
        },
      ],
    },
    theChartData: {
      required: true,
    },
  },
  data() {
    return {
      chartData: {
        labels: this.theChartData.labels,
        datasets: [
          {
            type: "line",
            label: "Gross Sales",
            data: this.theChartData.grossAmounts,
            backgroundColor: "RGBA(171, 71, 188, 0.1)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#AB47BC",
            fill: true,
            hidden: false,
          },
          {
            type: "line",
            label: "Payouts",
            data: this.theChartData.distributedPrizes,
            backgroundColor: "RGBA(236, 64, 122, 0.1)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#EC407A",
            fill: true,
            hidden: false,
          },
          {
            type: "line",
            label: "Gross Gaming Revenue",
            data: this.theChartData.netAmount,
            backgroundColor: "RGBA(255, 167, 38, 0.1)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#FFA726",
            fill: true,
            hidden: false,
          },
          {
            type: "line",
            label: "PAGCOR Share",
            data: this.theChartData.pagcorShare,
            backgroundColor: "RGBA(92, 107, 192, 0.1)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#5C6BC0",
            fill: true,
            hidden: false,
          },
          {
            type: "line",
            label: "Net Amount",
            data: this.theChartData.netIncome,
            backgroundColor: "RGBA(129, 199, 132, 0.1)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#81C784",
            fill: true,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: 0.4,
        plugins: {
          legend: {
            display: true,
            position: "top",
            labels: {
              font: {
                size: 13,
                family: "Poppins",
              },
              padding: 16,
              boxWidth: 12,
              boxHeight: 12,
            },
          },
        },
        scales: {
          xAxes: {
            grid: {
              display: false,
              drawBorder: false,
              drawTicks: true,
              tickColor: "#FFFFFF",
            },
            ticks: {
              display: true,
              font: {
                family: "Poppins"
              },
            },
          },
          yAxes: {
            grid: {
              drawBorder: false,
              drawTicks: true,
              tickColor: "#FFFFFF",
              color: "#DDDDDD",
              borderDash: [5, 5],
              borderDashOffset: 2,
            },
            ticks: {
              display: true,
              font: {
                family: "Poppins"
              },
            },
          },
        },
      },
    };
  },
};
</script>
